export default "__VITE_ASSET__B$xGHISH__"